import gql from 'graphql-tag';

export const GET_CUSTOMER = gql`
  query GetCustomer(
    $id: String!
    $salesOrgs: [String]
    $businessAreas: [BusinessAreaInput!]
  ) {
    customer(id: $id, salesOrgs: $salesOrgs, businessAreas: $businessAreas) {
      soldTo {
        id
        salesOrg
        division
        distributionChannel
        address {
          name
          street
          city
          postalCode
          region
          country
        }
      }
      shipTo {
        id
        salesOrg
        address {
          name
          street
          city
          postalCode
          region
          country
        }
      }
    }
  }
`;
